import { useEffect, useState } from "react";

import { updateSecuritySettings } from "../../services/settingsApi";

function SecuritySettings({ settings, reload }) {

    const [formData, setFormData] = useState({
        sessionTimeout: "",
        minimumPasswordLength: "",
        twoFactorAuth: false,
    });

    useEffect(() => {

        if (settings) {

            setFormData({
                sessionTimeout: settings.sessionTimeout || "",
                minimumPasswordLength: settings.minimumPasswordLength || "",
                twoFactorAuth: settings.twoFactorAuth || false,
            });

        }

    }, [settings]);

    const handleChange = (e) => {

        const { name, value, type, checked } = e.target;

        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            await updateSecuritySettings(formData);

            alert("Security settings updated successfully.");

            reload();

        } catch (error) {

            console.error(error);

            alert("Failed to update security settings.");

        }

    };

    return (

        <form
            className="settings-form"
            onSubmit={handleSubmit}
        >

            <div className="settings-card">

                <h2>Security Settings</h2>

                <div className="settings-grid">

                    <div className="form-group">

                        <label>Session Timeout (Minutes)</label>

                        <input
                            type="number"
                            name="sessionTimeout"
                            value={formData.sessionTimeout}
                            onChange={handleChange}
                            min="1"
                        />

                    </div>

                    <div className="form-group">

                        <label>Minimum Password Length</label>

                        <input
                            type="number"
                            name="minimumPasswordLength"
                            value={formData.minimumPasswordLength}
                            onChange={handleChange}
                            min="6"
                        />

                    </div>

                    <div className="form-group checkbox-group">

                        <label>

                            <input
                                type="checkbox"
                                name="twoFactorAuth"
                                checked={formData.twoFactorAuth}
                                onChange={handleChange}
                            />

                            Enable Two-Factor Authentication

                        </label>

                    </div>

                </div>

                <button
                    type="submit"
                    className="save-btn"
                >
                    Save Security Settings
                </button>

            </div>

        </form>

    );

}

export default SecuritySettings;